import { FACET_FINDINGAIDS } from "../actions/types";

const initialState = {
  facets: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FACET_FINDINGAIDS:
      return {
        facets: action.payload,
      };
    default:
      // console.log('DEFAULT FINDING AIDS')
      return state;
  }
}
